'use client'
import { type FC, type ReactNode } from 'react'
import dynamic from 'next/dynamic'
import StyledComponentsRegistry from '@/utils/styled-components-registry'
import { Susy } from '@/styles'
import { PRO, STAGING } from '@/utils'
import { TranslationsProvider, ModalsProvider, ToastProvider, VideoVisibilityProvider } from '@/context'
import { TransitionWrapper } from './TransitionWrapper'
import type { TypeLang } from '@/schema'
import { Navbar } from '../layout/Navbar'
import { AsidePreFooter } from '../layout/AsidePreFooter'
import { Footer } from '../layout/Footer'

type Props = {
  children: ReactNode
  lang?: TypeLang
}

const DynamicModalMenu = dynamic(() => import('../modals/ModalMenu').then(mod => mod.ModalMenu), { ssr: false })
const DynamicModalContact = dynamic(() => import('../modals/ModalContact').then(mod => mod.ModalContact), { ssr: false })
const DynamicModalVideo = dynamic(() => import('../modals/ModalVideo').then(mod => mod.ModalVideo), { ssr: false })

const ClientProviders: FC<Props> = ({ children, lang }) => {
  return (
    <StyledComponentsRegistry>
      <TranslationsProvider paramLang={lang}>
        <ToastProvider>
          <VideoVisibilityProvider>
            <ModalsProvider>
              <TransitionWrapper>
                <Navbar />
                {children}
                <AsidePreFooter />
                <Footer />
                <DynamicModalVideo />
                <DynamicModalMenu />
                <DynamicModalContact />
              </TransitionWrapper>
            </ModalsProvider>
          </VideoVisibilityProvider>
        </ToastProvider>
      </TranslationsProvider>
      {(!STAGING && !PRO) && <Susy />}
    </StyledComponentsRegistry>
  )
}

export default ClientProviders
